const config = {
  apiHost: import.meta.env.VITE_APP_API_HOST,
  aiMainframeHost: import.meta.env.VITE_APP_AI_MAINFRAME_HOST,
  intercomId: import.meta.env.VITE_APP_INTERCOM_APP_ID,
  placesApiKey: import.meta.env.VITE_APP_PLACES_API_KEY,
  streamApiKey: import.meta.env.VITE_APP_STREAM_KEY,
  environment: import.meta.env.VITE_APP_ENV,
  posthog: {
    key: import.meta.env.VITE_APP_POSTHOG_KEY,
    host: "https://us.i.posthog.com"
  },
  stripePk: import.meta.env.VITE_APP_STRIPE_PK,
  axOrigin: import.meta.env.VITE_APP_AX_ORIGIN,
  buildId: import.meta.env.VITE_APP_SHA,
  sentryDsn: import.meta.env.VITE_APP_SENTRY_DSN
};

export default config;
